import { useState, useEffect } from 'react'

/**
 * Hook to detect mobile viewport.
 *
 * @param breakpoint - The max width in px to consider as mobile (default 1024, lg breakpoint)
 * @returns Whether the current viewport is mobile-sized
 */
export function useIsMobile(breakpoint = 1024): boolean {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [breakpoint])

  return isMobile
}
